import { t } from "../../../data/strings";
import type { FlSkillId, HudSnapshot } from "../../../features/frontline";

export function topHtml(): string {
  return `
    <div class="fl-noti-rail fl-noti-ai" data-noti-ai aria-live="polite"></div>
    <div class="fl-noti-rail fl-noti-user" data-noti-user aria-live="polite"></div>
    <div class="fl-top-row">
      <div class="fl-chip" data-timer></div>
      <div class="fl-bases">
        <span class="fl-chip" data-base-enemy></span>
        <span class="fl-chip" data-base-ally></span>
      </div>
      <button type="button" class="fl-icon-btn" data-quit>${t("fl.quit")}</button>
    </div>
    <div class="fl-msg" data-msg>${t("fl.msg.hint")}</div>
    <div class="fl-chip fl-elite" data-elite></div>
  `;
}

export function dockHtml(): string {
  return `
    <div class="fl-dock-stack">
      <div class="fl-mana-row">
        <div class="fl-mana-bar" data-mana-bar>
          <div class="fl-mana-fill" data-mana-fill></div>
        </div>
        <span class="fl-chip" data-mana-text></span>
        <span class="fl-chip" data-deck></span>
      </div>
      <div class="fl-dock-inner fl-skill-row" data-hand></div>
      <div class="fl-chip" data-owned></div>
    </div>
  `;
}

export function handCardsHtml(
  hand: FlSkillId[],
  selectedIndex: number | null,
  mana: number,
  costs: Record<FlSkillId, number>,
  exile: Record<FlSkillId, boolean>,
): string {
  if (hand.length === 0) {
    return `<div class="fl-chip">${t("fl.hand.empty")}</div>`;
  }
  return hand
    .map((id, i) => {
      const cost = costs[id] ?? 0;
      const afford = mana >= cost;
      const active = selectedIndex === i ? " is-active" : "";
      const ready = afford ? " is-ready" : " is-poor";
      const vanish = exile[id] ? " is-exile" : "";
      const exileTag = exile[id]
        ? `<span class="fl-card-exile">${t("fl.keyword.exile")}</span>`
        : "";
      return `
      <button type="button" class="fl-card${active}${ready}${vanish}" data-skill="${id}" data-hand-idx="${i}">
        <span class="fl-card-name">${t(`fl.skill.${id}`)}</span>
        ${exileTag}
        <span class="fl-card-hint">${t(`fl.skill.hint.${id}`)}</span>
        <span class="fl-card-cost" data-skill-cost="${id}">${cost}</span>
      </button>`;
    })
    .join("");
}

export function resultHtml(phase: HudSnapshot["phase"]): string {
  const title =
    phase === "won"
      ? t("fl.result.won")
      : phase === "lost"
        ? t("fl.result.lost")
        : t("fl.result.draw");
  return `
    <div class="fl-result-card">
      <h2>${title}</h2>
      <button type="button" class="menu-btn" data-restart>${t("fl.restart")}</button>
      <button type="button" class="menu-btn" data-quit>${t("fl.quit")}</button>
    </div>
  `;
}
